import script from "./ChapterItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterItem.vue?vue&type=script&setup=true&lang=js"

import "./ChapterItem.vue?vue&type=style&index=0&id=04b8b1a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b8b1a1"]])

export default __exports__